import React, { Component } from "react";
import BusinessInput from "./BusinessInput/BusinessInput";
import Button from "../../Button/Button";
import "./PanelRight.css";

class PanelRight extends Component {
	render() {
		return (
			<div
				className="panel panel-right"
				style={{ backgroundImage: `url(${this.props.trianglify})`, backgroundSize: 'cover' }}
			>
				<BusinessInput
					query={this.props.query}
					buildSearchQuery={this.props.buildSearchQuery}
				/>
				<Button
					label={`Find ${this.props.query.type}`}
					onClick={() => this.props.validateSearchQuery()}
				/>
			</div>
		);
	}
}

export default PanelRight;


// WEBPACK FOOTER //
// ./src/components/Search/PanelRight/PanelRight.js